import {Injectable} from '@angular/core';
import {AthenaMessage} from './model/athena-message';
import {BehaviorSubject, map, Observable, startWith, Subject, switchMap, timer} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AthenaService {
  private queue: AthenaMessage[] = [];
  openHelpBar$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  reset$ = new Subject();
  messages$: Observable<AthenaMessage>;

  constructor() {
    this.messages$ = this.reset$.pipe(
      startWith(void ''),
      switchMap(() => timer(0, 15000))
    ).pipe(
      map(() => {
        return this.queue.shift();
      }),
      map((message) => {
        return message || {
          message: '',
          isValid: () => true,
        };
      })
    );
  }

  sendMessage(message: AthenaMessage) {
    this.reset$.next(void message);
    this.queue.push(message);
  }
}
